import { render, staticRenderFns } from "./RisksAnalysisArchive.vue?vue&type=template&id=6f3603fe&scoped=true"
import script from "./RisksAnalysisArchive.vue?vue&type=script&lang=js"
export * from "./RisksAnalysisArchive.vue?vue&type=script&lang=js"
import style0 from "./RisksAnalysisArchive.vue?vue&type=style&index=0&id=6f3603fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3603fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLazy,VPagination,VRow})
